import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	useAgentLabel: {
		id: 'autodev.agent-picker-bulk.use-agent-label',
		defaultMessage: 'Use coding agent',
		description: 'The label of the floating toolbar button that opens Rovo agent picker.',
	},
	unexpectedErrorMessage: {
		id: 'autodev.agent-picker-bulk.use-agent-unexpected-error-message',
		defaultMessage: 'Something went wrong',
		description: 'The label that will be displayed when something unexpected happens',
	},
});
